import { render, staticRenderFns } from "./TutorialFolder.vue?vue&type=template&id=6c82dcf1"
import script from "./TutorialFolder.vue?vue&type=script&lang=ts"
export * from "./TutorialFolder.vue?vue&type=script&lang=ts"
import style0 from "./TutorialFolder.vue?vue&type=style&index=0&id=6c82dcf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports